import React, { useState, useEffect, useRef, useCallback } from "react";
import tw from "tailwind-styled-components";
import { useMutation } from "react-query";
import axios from "axios";
import Config from "../../Config";
import Loading from "../../Components/Loading";
import Table from "../../Components/Dues/Table";
import { toast } from "react-toastify";
import {
  BoxContainer,
  BoxTitle,
  Underline,
  BoxHead,
  FilterTableWrapper,
  FilterWrapper
} from "../../Components/Styles/PageStyles";
import NotFoundModel from "../../Components/NotFoundModel";
import ViewDueDetails from "../../Components/Dues/ViewDetail";
import { useDispatch, useSelector } from "react-redux";
import EditDuesModel from "../../Components/Dues/EditDuesModel";
import SummaryCard from "../../Components/Dues/SummaryCard";
import moment from "moment";
import MarkAsPaidModal from "../../Components/Dues/MarkAsPaidModel";
import { SummarySkeletonLoading } from "../../Components/SkeletonLoading";
import SearchFilterBox from "../../Components/SearchFilterBox";
import DateRange from "../../Components/DateRange";
import RemainderAll from "../../Components/Dues/RemainderAll";
import SideModal from "../../Components/SideModal";
import PropertiesFilterDropdown from "../../Components/PropertiesFilterDropdown";
import PaymentLinkModal from "../../Components/PaymentLinkModal";
import { getPaymentLinkAndQr } from "../../utilities/paymentLink.api";
import { IoFilter } from "react-icons/io5";
import FilterModal from "../../Components/Dues/FilterModal";
import HiddenDuesTable from "../../Components/Dues/HiddenDuesTable";
import Notes from "../../Components/Tenants/Notes";
import { Select_Location } from "../../Redux/actions";
import { AddBtn } from "../../Components/Styles/InputStyles";

const Dues = () => {
  const searchOptions = [
    { label: "Mobile", value: 1 },
    { label: "Name", value: 2 },
    { label: "Property", value: 3 },
  ];
  const dispatch = useDispatch();
  const storageKey = `tenant_dues_filter`;
  const properties = useSelector((state) => state.PropertyReducer.property);
  const [showNotesModal, setShowNotesModal] = useState(false);
  const [showPaymentLinkModal, setShowPaymentLinkModal] = useState(false);
  const [paymentData, setPaymentData] = useState(null);
  const [isEditDue, setIsEditDues] = useState(false);
  const [loadingId, setLoadingId] = useState(null);
  const [isShowDueDetails, setShowDueDetails] = useState(false);
  const user = useSelector((state) => state.UserReducer.user);
  const [isViewNotes, setIsViewNotes] = useState(false);
  const [selectedId, setSelectedId] = useState(null);

  const [activeFilter, setActiveFilter] = useState({
    value: "",
    label: "",
    title: "",
  });
  const [isFilterOpen, setIsFilterOpen] = useState(false);
  const [filterSource, setFilterSource] = useState(null);
  const [hideLoadingId, setHideLoadingId] = useState(null);

  const canMarkPaymentPaid =
    user?.userType === Config.USER_TYPE.CLIENT || user?.role === Config.USER_TYPE.PARTNER ||
    (user?.userType === Config.USER_TYPE.STAFF &&
      user?.role === Config.STAFF_ROLES.ADMIN) ||
    (user?.userType === Config.USER_TYPE.STAFF &&
      user?.role === Config.STAFF_ROLES.WARDEN);

  const isFirstLoad = useRef(true);
  const property = useSelector(
    (state) => state.SelectPropertyReducer.selectProperty
  );
  const location = useSelector(
    (state) => state.SelectLocationReducer.selectLocation
  );
  const [filterType, setFilterType] = useState("");
  const [searchQuery, setSearchQuery] = useState("");
  const [isFocused, setIsFocused] = useState(false);
  const [isRemainderAll, setIsRemainderAll] = useState(false);
  const [selectedData, setSelectedData] = useState("");
  // const [filterValue, setFilterValue] = useState("MA");
  const [filterValue, setFilterValue] = useState("SORT_MA");
  const [filter, setFilter] = useState("");
  const [locationFilter, setLocationFilter] = useState("");
  const [apiData, setApiData] = useState();
  const [masterData, setMasterData] = useState();
  const [selectedProperty, setSelectedProperty] = useState(property);

  const [summary, setSummary] = useState({
    totalDues: 0,
    overDuesAmt: 0,
    currentMonthDues: 0,
    rentDues: 0,
  });

  const [startDate, setStartDate] = useState(() => {
    return (
      sessionStorage.getItem("due_startDate") ||
      moment().startOf("month").format("YYYY-MM-DD")
    );
  });

  const [endDate, setEndDate] = useState(() => {
    return (
      sessionStorage.getItem("due_endDate") ||
      moment().endOf("month").format("YYYY-MM-DD")
    );
  });

  const [isMarkAsPaidVisible, setIsMarkAsPaidVisible] = useState(false);

  const isHideDuesFilter = filter === "HD";

  const updateFilterForLocation = useCallback((location) => {
    if (!location || !location.id || location.id === 0) {
      setLocationFilter('');
      setFilterValue("SORT_MA");
      setActiveFilter({ value: "", label: "", title: "" });
      return;
    }

    const locationFilterValue = `LOC_${location.id}`;
    setLocationFilter(location.id.toString());
    setFilterValue(locationFilterValue);
    setFilter('L')

    setActiveFilter({
      value: location.id.toString(),
      label: location.name || `Location ${location.id}`,
      title: 'Locations'
    });
  }, []);

  const getFetchFunction = async () => {

    // const query = `&startDate=${startDate}&endDate=${endDate}&propId= ${filter === 'L' ? 0 : (selectedProperty?.id || 0)}&s=${searchQuery}&t=${filterType}&filter=${filter}&locationFilter=${locationFilter}`;
    const query = `&startDate=${startDate}&endDate=${endDate}&propId=${selectedProperty?.id}&s=${searchQuery}&t=${filterType}&filter=${filter}&locationFilter=${locationFilter}`;
    const response = await axios.get(`${Config.apiUrl}/due/web/list?${query}`, {
      headers: {
        authorization: "Bearer" + " " + user.token,
        "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
      },
    });
    return response.data;
  };

  const getSuccess = (res) => {
    if (res.isSuccess === false) {
      toast.error(res.msg || "An error occurred");
      return;
    } else {
      setApiData(res?.dues || []);
      setMasterData(res?.dues || []);
      // setSelectedId(null);
      setSummary(res?.summary || {
        totalDues: 0,
        overDuesAmt: 0,
        currentMonthDues: 0,
        rentDues: 0,
      });

      setIsFocused(true);
    }
  };

  const getError = (res) => {
    toast.error(res.message || "Failed to fetch dues");
  };

  const {
    isLoading,
    mutate: getListMutate,
    error,
    data,
    isRefetching,
  } = useMutation(getFetchFunction, {
    onSuccess: getSuccess,
    onError: getError,
  });
  const canHideDues = data?.canHideDues

  useEffect(() => {
    updateFilterForLocation(location);
  }, [location, updateFilterForLocation]);

  useEffect(() => {
    if (!startDate || !endDate) return;

    const timer = setTimeout(() => {
      getListMutate();
    }, 100);

    return () => clearTimeout(timer);
  }, [
    filter,
    selectedProperty?.id,
    searchQuery,
    filterType,
    startDate,
    endDate,
    locationFilter,
    getListMutate
  ]);

  useEffect(() => {
    if (startDate) sessionStorage.setItem("due_startDate", startDate);
    if (endDate) sessionStorage.setItem("due_endDate", endDate);
  }, [startDate, endDate]);

  const submitHandler = (values) => {
    const newValues = {
      startDate: moment(values.startDate).format("YYYY-MM-DD"),
      endDate: moment(values.endDate).format("YYYY-MM-DD"),
    };
    setFilter("");
    setLocationFilter("");
    setActiveFilter({ value: "", label: "", title: "" });
    setFilterType("");
    setSearchQuery("");
    setStartDate(newValues.startDate);
    setEndDate(newValues.endDate);
  };

  const onApplyFilter = (value, label, title) => {
    sessionStorage.removeItem("tenant_dues_page");
    setFilterSource("dropdown");
    setIsFilterOpen(false);

    let prefixedValue = value;
    let newLocationFilter = "";
    let newFilter = "";
    if (title === 'Due Type') {
      prefixedValue = `DUE_${value}`;
      sessionStorage.setItem("tenant_dues_filter", prefixedValue);
      setFilterValue(prefixedValue);
      const filteredData = masterData.filter(
        item => item.type === Number(value)
      );
      setApiData(filteredData);
      setActiveFilter({ value, label, title });
      return;
    }

    switch (title) {
      case 'Locations':
        prefixedValue = `LOC_${value}`;
        newLocationFilter = value;
        newFilter = "L";
        break;
      case 'Sort By':
        prefixedValue = `SORT_${value}`;
        newFilter = value;
        break;
      case 'Pending Duration':
        prefixedValue = `PEND_${value}`;
        newFilter = value;
        break;
      case 'Hidden Dues':
        prefixedValue = `HIDE_${value}`;
        newFilter = "HD";
        break;
      default:
        prefixedValue = `SORT_${value}`;
        newFilter = value;
    }

    setFilterType("");
    setSearchQuery("");
    setFilter("");
    setLocationFilter("");

    if (title === 'Locations') {
      setFilter(newFilter);
      setLocationFilter(value);
    } else {
      setFilter(newFilter);
    }

    sessionStorage.setItem("tenant_dues_filter", prefixedValue);
    setFilterValue(prefixedValue);
    setActiveFilter({ value, label, title });
  };

  useEffect(() => {
    if (filter === "L" && locationFilter) {
      setSelectedProperty({
        id: 0,
        name: "All Properties",
        gId: "KIPINN",
        type: 0,
        tenantPreference: 3,
        tenantCount: 634
      });
    }
  }, [filter, locationFilter]);

  const handleClearFilters = () => {
    setFilterSource(null);
    setActiveFilter({ value: "", label: "", title: "" });
    sessionStorage.removeItem("tenant_dues_filter");
    setFilter("");
    setFilterType("");
    setFilterValue("SORT_MA");
    setSearchQuery("");
    setLocationFilter("");
    setSelectedId(null)
    setIsFilterOpen(false);
    dispatch(Select_Location({ id: 0, name: "All Locations", clientId: 0 }));
  };

  const panelRef = useRef(null);
  const btnRef = useRef(null);

  useEffect(() => {
    if (!isFilterOpen) return;
    const onKey = (e) => {
      if (e.key === "Escape") setIsFilterOpen(false);
    };
    const onClickOutside = (e) => {
      if (
        panelRef.current &&
        !panelRef.current.contains(e.target) &&
        btnRef.current &&
        !btnRef.current.contains(e.target)
      ) {
        setIsFilterOpen(false);
      }
    };
    document.addEventListener("keydown", onKey);
    document.addEventListener("mousedown", onClickOutside);
    return () => {
      document.removeEventListener("keydown", onKey);
      document.removeEventListener("mousedown", onClickOutside);
    };
  }, [isFilterOpen]);

  //------- Edit Dues Function -------
  const editDuesFunction = async (values) => {
    const payload = {
      dueId: values.id,
      newAmount: Number(values.balance),
      isTemp: false,
      tenantId: selectedData.tenantId,
      isEvicted: false,
    };

    return await axios.post(`${Config.apiUrl}/due/edit/new`, payload, {
      headers: {
        authorization: "Bearer" + " " + user.token,
        "Content-Type": "application/json",
      },
    });
  };

  const onEditDueSuccess = (data) => {
    if (data?.data?.isSuccess === true) {
      toast.success(data?.data?.msg || "Success");
      setActiveFilter({ value: "", label: "", title: "" });
      sessionStorage.removeItem("tenant_dues_filter");
      getListMutate();
    } else {
      toast.error(data?.data?.msg || "An Error Occurred");
    }
    setSelectedData("");
    setIsEditDues(false);
  };

  const onEditDueError = (data) => {
    setIsEditDues(false);
    setSelectedData("");
    toast.error(data?.response?.data?.msg || "An Error Occurred");
  };

  const { isLoading: editDueLoading, mutate: editDuesMutate } = useMutation(
    editDuesFunction,
    {
      onSuccess: onEditDueSuccess,
      onError: onEditDueError,
    }
  );

  //------- Send Reminder Function -------
  const sendReminderFunction = async (values) => {
    const payload = {
      tenantId: values.tenantId,
    };
    //return;
    return await axios.post(
      `${Config.apiUrl}/client/reminded-tenant/`,
      payload,
      {
        headers: {
          authorization: "Bearer" + " " + user.token,
          "Content-Type": "application/json",
        },
      }
    );
  };

  const onSendReminderSuccess = (data) => {
    if (data?.data?.isSuccess === true) {
      toast.success(data?.data?.msg || "Success");
      setIsRemainderAll(false);
    } else {
      toast.error(data?.data?.msg || "An Error Occurred");
    }
    setSelectedData("");
  };

  const onSendReminderError = (data) => {
    setSelectedData("");
    toast.error(data?.response?.data?.msg || "An Error Occurred");
  };

  const { isLoading: sendReminderLoading, mutate: sendReminderMutate } =
    useMutation(sendReminderFunction, {
      onSuccess: onSendReminderSuccess,
      onError: onSendReminderError,
    });

  const onSummaryBoxClick = (data) => {

    sessionStorage.removeItem("tenant_dues_page");
    setFilterSource("summary");
    setFilterType("");
    setSearchQuery("");
    setSelectedId(data);
    sessionStorage.setItem("tenant_dues_filter", data);
    const handler = setTimeout(() => {
      setFilter(data);
    }, 50);
    return () => clearTimeout(handler);
  };

  //------- Mark as Paid Model -------
  const MarkAsPaidFunction = async (values) => {
    return await axios.post(`${Config.apiUrl}/due/paid/with/receipt`, values, {
      headers: {
        "Content-Type": "application/json",
        authorization: `Bearer ${user.token}`,
      },
    });
  };

  const markAsPaidSuccess = (data) => {
    setIsMarkAsPaidVisible(false);
    getListMutate();
    toast.success(data?.data?.msg || "Success");
  };

  const markAsPaidError = (data) => {
    setIsMarkAsPaidVisible(false);
    toast.error(data?.response?.data?.msg || "An Error Occurred");
  };

  const { isLoading: markAsPaidLoading, mutate: markAsPaidMutate } =
    useMutation(MarkAsPaidFunction, {
      onSuccess: markAsPaidSuccess,
      onError: markAsPaidError,
    });

  //------- Hide Due Model -------
  const hideDueFunction = async (payload) => {
    return await axios.post(`${Config.apiUrl}/due/toggle`, payload, {
      headers: {
        authorization: `Bearer ${user.token}`,
      },
    });
  };

  const { isLoading: hideDueLoading, mutate: hideDueMutate } = useMutation(
    hideDueFunction,
    {
      onSettled: () => {
        setIsEditDues(false);
        setHideLoadingId(null);
      },
      onSuccess: ({ data }) => {
        getListMutate();
        toast.success(data?.msg || 'Success');
      },
      onError: (error) => {
        toast.error(error?.response?.data?.msg || 'An error occurred');
      },
    }
  );

  const handleFilterChange = (values) => {
    setFilterType(values.filterType);
    setSearchQuery(values.searchQuery);
    sessionStorage.removeItem("tenant_dues_page");
    sessionStorage.removeItem(storageKey);
    const handler = setTimeout(() => {
      getListMutate();
    }, 100);
    return () => {
      clearTimeout(handler);
    };
  };

  const downloadQuery = `&startDate=${startDate}&endDate=${endDate}&s=${searchQuery}&t=${filterType}&propId=${property?.id
    }&filter=${filter}&locationFilter=${locationFilter}&fileType=${1}&reportType=${2}`;
  const [reportUrl, setReportUrl] = useState();

  useEffect(() => {
    if (reportUrl) {
      const link = document.createElement("a");
      link.href = reportUrl;
      link.setAttribute("download", "");
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);

      setReportUrl(null);
    }
  }, [reportUrl]);

  const downloadFunction = async (values) => {
    const response = await axios.get(
      `${Config.apiUrl}/report/generate?${downloadQuery}`,
      {
        headers: {
          authorization: "Bearer " + user.token,
          "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
        },
      }
    );
    return response.data;
  };

  const onDownloadSuccess = (res) => {
    if (res.isSuccess === false) {
      toast.error(res.msg || "No data found for the selected date range");
    } else if (res.reportUrl === false) {
      toast.error("No data found for the selected date range");
    } else {
      setReportUrl(res.reportUrl);
      toast.success(res.msg || "Report generated successfully");
    }
  };

  const onDownloadError = (res) => {
    toast.error(res.message || "Failed to download report");
  };

  const {
    mutate: downloadReport,
    isLoading: isDownloading,
    error: reportError,
  } = useMutation(downloadFunction, {
    onSuccess: onDownloadSuccess,
    onError: onDownloadError,
  });

  //------- Add/Edit Remark Model -------
  const AddEditRemarkFunction = async (values) => {
    return await axios.post(`${Config.apiUrl}/due/set/remarks`, values, {
      headers: {
        "Content-Type": "application/json",
        authorization: `Bearer ${user.token}`,
      },
    });
  };

  const addEditRemarkSuccess = (data) => {
    if (data?.data?.isSuccess === true) {
      toast.success(data?.data?.msg);
      setShowNotesModal(false);
      setShowDueDetails(false);
      getListMutate();
    } else {
      toast.success(data?.data?.msg);
    }
  };

  const addEditRemarkError = (data) => {
    // setIsMarkAsPaidVisible(false);
    // toast.error(data?.response?.data?.msg || "An Error Occurred");
  };

  const { isLoading: addEditRemarkLoading, mutate: addEditRemarkMutate } =
    useMutation(AddEditRemarkFunction, {
      onSuccess: addEditRemarkSuccess,
      onError: addEditRemarkError,
    });

  const handlePropertySelect = (property) => {
    sessionStorage.removeItem("tenant_dues_page");
    sessionStorage.removeItem(storageKey);
    setSelectedProperty(property);
    handleClearFilters()
  };

  const loadPaymentLinkModal = async (dueId) => {
    setLoadingId(dueId); // start loader for this row
    const res = await getPaymentLinkAndQr(user.token, dueId);
    setLoadingId(null);
    if (!res.success) {
      toast.error(res.error);
      return;
    }
    if (res.paymentLink) {
      setPaymentData(res);
      setShowPaymentLinkModal(true);
    }
    else {
      const encodedMsg = encodeURIComponent(res.reminderText);
      const url = `https://wa.me/+91${res.mobile}?text=${encodedMsg}`;
      window.open(url, "_blank"); // Opens WhatsApp in a new tab
    }
  };

  const handleFilterClose = () => {
    setIsFilterOpen(false);
  };

  const handleDetailModalClose = () => {
    setShowDueDetails(false);
    setShowNotesModal(false)
  };

  return (
    <>
      <BoxContainer>
        <BoxHead>
          <BoxTitle className="!mb-0 whitespace-nowrap">
            Dues
            <Underline />
          </BoxTitle>
          <div className="flex space-x-4 md:ml-auto">
            {data?.canSendBulkReminder === 1 && (
              <AddBtn
                type="button"
                onClick={() => {
                  setIsRemainderAll(true);
                }}
              >
                {"Remind All"}
              </AddBtn>
            )}
            <DownloadBtn type="button" onClick={() => downloadReport()}>
              {isDownloading ? "Downloading..." : "Download"}
            </DownloadBtn>
          </div>

        </BoxHead>

        <PaymentLinkModal
          isOpen={showPaymentLinkModal}
          onClose={() => setShowPaymentLinkModal(false)}
          paymentData={paymentData}
        />

        <SideModal
          isOpen={isFilterOpen}
          onClose={() => setIsFilterOpen(false)}
        >
          <FilterModal
            setIsFilterOpen={setIsFilterOpen}
            onApplyFilter={onApplyFilter}
            selectedData={selectedData}
            handleClose={handleFilterClose}
            currentFilter={filterValue}
            handleClearFilters={handleClearFilters}
            canHideDues={canHideDues}
          />
        </SideModal>


        <SideModal
          isOpen={isMarkAsPaidVisible}
          onClose={() => setIsMarkAsPaidVisible(false)}
        >
          <MarkAsPaidModal
            setIsMarkAsPaidVisible={setIsMarkAsPaidVisible}
            markAsPaidMutate={markAsPaidMutate}
            markAsPaidLoading={markAsPaidLoading}
            isMarkAsPaidVisible={isMarkAsPaidVisible}
            selectedData={selectedData}
            setSelectedData={setSelectedData}
            isEvicted={false}
            bankAccount={data?.bankAccounts}
            securityRemaining={selectedData?.securityRemaining}

          />
        </SideModal>

        {isEditDue && (
          <EditDuesModel
            editDuesMutate={editDuesMutate}
            editDueLoading={editDueLoading}
            setIsEditDues={setIsEditDues}
            data={data?.data}
            selectedData={selectedData}
            hideDueMutate={hideDueMutate}
            hideDueLoading={hideDueLoading}
            canHideDues={canHideDues}
          />
        )}
        {isRemainderAll && (
          <RemainderAll
            sendReminderMutate={sendReminderMutate}
            sendReminderLoading={sendReminderLoading}
            setIsRemainderAll={setIsRemainderAll}
          />
        )}

        <SideModal
          isOpen={isShowDueDetails}
          onClose={handleDetailModalClose}
        >
          <ViewDueDetails
            setShowDueDetails={setShowDueDetails}
            selectedData={selectedData}
            setIsEditDues={setIsEditDues}
            showNotesModal={showNotesModal}
            setShowNotesModal={setShowNotesModal}
            addEditRemarkMutate={addEditRemarkMutate}
            addEditRemarkLoading={addEditRemarkLoading}
            canMarkPaymentPaid={canMarkPaymentPaid}
          />
        </SideModal>

        <SideModal
          isOpen={isViewNotes}
          onClose={() => setIsViewNotes(false)}
        >
          <Notes
            isViewNotes={isViewNotes}
            setIsViewNotes={setIsViewNotes}
            selectedData={selectedData}
          />
        </SideModal>

        {(isLoading || isRefetching) && !isFocused && (
          <SummarySkeletonLoading count={5} />
        )}
        {isFocused && summary && (
          <>
            <SummaryCard summaryData={summary} onClick={onSummaryBoxClick} selectedId={selectedId} setSelectedId={setSelectedId} />
            <div className="hidden md:block ml-0 text-sm text-gray-600 mt-3">
              <strong className="text-gray-800">Pending Dues:</strong>{" "}
              <span className="text-gray-600 font-medium">
                {'₹' + (summary?.currentMonthDues || '0')}
              </span>
              {' from ' + (summary?.dueTenantCount || '0') + ' tenants'}
            </div>
            <FilterTableWrapper className='mt-4'>
              <FilterWrapper>
                <div className="flex flex-col md:flex-row md:items-center gap-4">
                  <SearchFilterBox
                    options={searchOptions}
                    handleFilterChange={handleFilterChange}
                    handleClearFilters={handleClearFilters}
                  />
                  <div className="hidden md:block">
                    <DateRange
                      submitHandler={submitHandler}
                      defaultLabel={
                        moment(startDate).format("DD MMM yyyy") +
                        " - " +
                        moment(endDate).format("DD MMM yyyy")
                      }
                    />
                  </div>
                </div>
                <div className="flex gap-2 justify-end items-center">

                  <PropertiesFilterDropdown
                    properties={properties}
                    selectedProperty={selectedProperty}
                    onPropertySelect={handlePropertySelect}
                    placeholder="Select Property"
                    className="min-w-[200px] w-full md:w-[220px]"
                  />
                  <div className="relative">
                    <FilterBtn
                      ref={btnRef}
                      type="button"
                      title="Tenant Filter"
                      onClick={() => setIsFilterOpen((v) => !v)}
                    >
                      <IoFilter size={14} color="#9CA3AF" />
                      {activeFilter?.value && (
                        <span className="absolute -top-1 -right-1 h-2.5 w-2.5 rounded-full bg-yellow-500 border border-white" />
                      )}
                    </FilterBtn>
                  </div>
                </div>
              </FilterWrapper>
              {!error && !isLoading && apiData && (
                <TableWrapper>
                  {isHideDuesFilter ?
                    <HiddenDuesTable
                      apiData={apiData}
                      setSelectedData={setSelectedData}
                      selectedData={selectedData}
                      hideDueLoading={hideDueLoading}
                      hideDueMutate={hideDueMutate}
                      setHideLoadingId={setHideLoadingId}
                      hideLoadingId={hideLoadingId}
                    /> :
                    <Table
                      apiData={apiData}
                      setSelectedData={setSelectedData}
                      setShowDueDetails={setShowDueDetails}
                      setIsMarkAsPaidVisible={setIsMarkAsPaidVisible}
                      selectedData={selectedData}
                      userType={user.userType}
                      sendReminderMutate={sendReminderMutate}
                      canMarkPaymentPaid={canMarkPaymentPaid}
                      loadPaymentLinkModal={loadPaymentLinkModal}
                      loadingId={loadingId}
                      isHideDuesView={isHideDuesFilter}
                      setIsViewNotes={setIsViewNotes}
                    />}
                  {(error || apiData.length === 0) && !isLoading && (
                    <NotFoundModel msg={isHideDuesFilter ? "No Hidden Dues" : "No Dues Pending"} />
                  )}
                </TableWrapper>
              )}
            </FilterTableWrapper>
          </>
        )}
        {error && !isLoading && <NotFoundModel />}
        {(isLoading || isRefetching) && <Loading />}
      </BoxContainer>
    </>
  );
};

const TableWrapper = tw.h1`mt-4 bg-white rounded-md `;
const DownloadBtn = tw.button`${(p) =>
  p.$active
    ? "bg-gray-100"
    : ""} border whitespace-nowrap border-primary-color flex space-x-1.5 justify-center items-center text-primary-color rounded-md px-6 cursor-pointer bg-white hover:bg-hover-color h-full py-2.5 text-sm`;
const FilterBtn = tw.button`flex items-center border whitespace-nowrap border-gray-300 justify-center rounded-md px-4 cursor-pointer bg-white hover:bg-gray-200 h-10 text-sm ml-auto`;
export default Dues;
